import React from "react";
import Pagination from "../common/Pagination";
import SeoComponent from "../common/SeoComponent";
import LayoutComponent from "../common/LayoutComponent";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import {fetchGalleries} from "../reducers/galleries";
import {t} from "../IntManager";
import {Link, Route, Switch} from "react-router-dom";
import NotFound from "./NotFound";

class Galleries extends SeoComponent {
    static fetchData(store, params) {
        return store.dispatch(fetchGalleries({page: params.page}));
    }

    componentDidMount() {
        this.fetchGalleries();
    }

    componentDidUpdate(prevProps) {
        if (this.props.match.params.page !== prevProps.match.params.page) {
            this.fetchGalleries();
        }
    }

    fetchGalleries() {
        this.props.fetchGalleries({page: this.props.match.params.page});
    }

    static renderGallery(item) {
        return <div key={item.id}>
            <Link to={`/galleries/${item.alias}`}>
                {item.title}
            </Link>
        </div>
    }

    render() {
        if (this.props.galleries.notFound) {
            return <Switch>
                <Route component={NotFound}/>
            </Switch>
        }

        let content;
        if (this.props.galleries.error) {
            content = <div>Не удалось получить данные с сервера</div>
        } else if (this.props.galleries.loading) {
            content = <div>Загрузка...</div>
        } else {
            const galleries = [];

            for (let id in this.props.galleries.items) {
                if (this.props.galleries.items.hasOwnProperty(id)) {
                    galleries.push(Galleries.renderGallery(this.props.galleries.items[id]))
                }
            }

            content = <div>
                {galleries}
                <Pagination {...this.props.galleries} url={'/galleries/page/'}/>
            </div>
        }

        this.setMetaTags(t('galleries'));

        return <LayoutComponent routerMatch={this.props.match}>
            <h1>{t('galleries')}</h1>
            {content}
        </LayoutComponent>;
    }
}

const mapStateToProps = (state) => {
    return {
        galleries: state.galleries,
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({fetchGalleries}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Galleries);



// WEBPACK FOOTER //
// ./src/js/components/Galleries.js